module.exports = __webpack_public_path__ + "static/media/arrow-left-circle-thin.1bd6cd2c.svg";